/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';

import { linkForPlace } from "../LinkHelper";
import { getCountryName } from "../place/GeoCountries";

import OutageCardTimeHeader from "./OutageCardTimeHeader";
import OutageSummary from "./OutageSummary";
import OutagePlaceList from "./OutagePlaceList";


class OutageCard extends Component {
    
    outage() {
        return this.props.outage;
    }

    renderHeader() {
        const outage = this.outage();

        return outage.aggType === 'ISP outage' ? this.renderIspHeader() : this.renderGenericHeader();
    }

    renderGenericHeader() {
        const outage = this.outage();

        let dimLength = outage.mainDimensionPath.length;
        let title = outage.mainDimensionPath[dimLength - 1];
        let subtitle = outage.mainDimensionPath.slice(0, dimLength - 1).reverse().join(', ');

        return (
            <div className="media align-items-center">
                <div className="avatar mr-3">
                    <img className="img-fluid" src={this.props.outage.imageUrl} alt="ISP Logo" />
                </div>
                <div className="media-body">
                    <h3 className="h6 mb-0">{title}</h3>
                    <div className="small">
                        {subtitle}
                    </div>
                </div>
            </div>
        );
    }

    renderIspHeader() {
        let outage = this.outage();

        let dimLength = outage.mainDimensionPath.length;
        let title = outage.mainDimensionPath[dimLength - 1];

        let isp = outage.mainDimensionIspValue;
        let region = outage.mainDimensionRegionValue;
        let country = outage.mainDimensionCountryValue;

        return (
            <div className="media">
                <div className="avatar mr-3">
                    <img className="img-fluid" src={this.props.outage.imageUrl} alt="ISP Logo" />
                </div>
                <div className="media-body">
                    <Link to={'/provider/' + isp + '/' + getCountryName(country) + (region ? '/' + region : '')}><span className="h6">{title}</span></Link>
                    <div className="small">
                        <Link
                            className="link-underline"
                            to={linkForPlace(getCountryName(country), region)}>{(region ? region + ', ' : '') + getCountryName(country)}</Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className={this.props.className}>
                <header className="card-header d-flex flex-column align-items-start p-6">
                    <OutageCardTimeHeader outage={this.props.outage} />
                    {this.renderHeader()}
                </header>

                <div className="card-body p-6">
                    <div>
                        <div className="mb-3">
                            <OutageSummary outage={this.props.outage} />
                        </div>

                        <div>
                            {this.props.outage.wideAreaImpact &&
                                <OutagePlaceList outage={this.props.outage} dimension='WideAreaImpact' compact='true' />
                            }
                            {!this.props.outage.wideAreaImpact &&
                                <OutagePlaceList outage={this.props.outage} dimension='City' compact='true' />
                            }
                            {!this.props.outage.wideAreaImpact &&
                                <OutagePlaceList outage={this.props.outage} dimension='Region' compact='true' />
                            }
                        </div>
                    </div>
                </div>

                <footer className="pl-6 pr-6 pb-4 mx-0">
                    <Link to={'/outage/' + encodeURIComponent(this.props.outage.reportId)}
                        className="btn btn-sm btn-block btn-soft-primary transition-3d-hover">{intl.get('outage_more')}</Link>
                </footer>

            </div>
        );
    }
}

export default OutageCard;